import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { WithTooltip, Button, kuiperClassNames } from '@opallabs/kuiper'
import { styles } from './styles'

const tooltipText = 'Please contact your Opal administrator to create labels'

export const LabelPickerLabel = ({
  hasLabels,
  styleOverrides,
  theme = 'dark',
}) => {
  const isAdmin = window.OpalMoments && window.OpalMoments.State.is_brand_admin
  const openLabelConfig = () => {
    const url =
      `${window.location.protocol}//${window.location.hostname}/` +
      `moments/${window.OpalMoments.State.current_brand_slug}/configure/label_sets`
    window.open(url, '_blank')
  }

  return (
    <Fragment>
      <span
        className={kuiperClassNames('label-picker-label')}
        css={styles.label(theme, styleOverrides)}
      >
        Labels
      </span>
      {!hasLabels && (
        <WithTooltip
          className="create-new-from-post"
          disabled={isAdmin}
          content={tooltipText}
          tooltipOptions={{ position: 'top' }}
        >
          <Button
            className="go-to-create-labels"
            disabled={!isAdmin}
            type="invisible"
            icon="share"
            iconOptions={{
              width: '12px',
              height: '12px',
            }}
            label="Create Labels"
            onClick={openLabelConfig}
            position="right"
            size="large"
          />
        </WithTooltip>
      )}
    </Fragment>
  )
}

LabelPickerLabel.propTypes = {
  hasLabels: PropTypes.bool.isRequired,
  styleOverrides: PropTypes.object,
  theme: PropTypes.oneOf(['light', 'dark']),
}
